/* eslint-disable no-underscore-dangle */
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { messageError } from 'views/ui/toast-message';
import SDK from 'utils/sdk';
import { SubmissionError } from 'redux-form';
import { getLocation } from './selectors';
import { getStaff } from './actions';
import { UPDATE_STAFF, UPDATE_REQUEST } from './type';

function* getStaffSaga() {
  try {
    yield put(getStaff.request());
    const selectedLocation = yield select(getLocation);
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'getStaffByLocation'], {
      id: selectedLocation._id,
    });
    yield put(getStaff.success(data));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(getStaff.failure(new SubmissionError({ _error: data })));
    messageError(data);
  } finally {
    yield put(getStaff.fulfill());
  }
}

function* updateStaffSaga({ payload }) {
  const client = yield call([SDK, 'getClient']);
  const { data } = yield call([client, 'updateStaff'], null, [payload]);
  yield put({ payload: data[0], type: UPDATE_STAFF });
}

export default function* authWatch() {
  yield takeLatest(getStaff.TRIGGER, getStaffSaga);
  yield takeLatest(UPDATE_REQUEST, updateStaffSaga);
}
